import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box} from 'views/components';

import DashboardCaregiverSearch from './dashboard_scene/DashboardCaregiverSearch';
import SkeletonSectionLoader from './dashboard_scene/skeleton_loader/SkeletonSectionLoader';

const DashboardView = (props) => {
  const {clientRn, statusProgressWrap: progressWrap} = props;

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    progressWrap(async () => {
      setLoading(true);
      setLoading(false);
    });
  }, [progressWrap, clientRn]);

  return (
    <Stack sx={{p: {xs: 0, lg: 2}, m: {xs: 0, lg: 0}}}>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          p: {xs: 0, lg: 2},
          m: {xs: 0, lg: 0},
        }}
      >
        {
          loading &&
          <SkeletonSectionLoader />
        }
        {
          !loading &&
          <DashboardCaregiverSearch />
        }
      </Box>
    </Stack>
  );
};

DashboardView.propTypes = {
  clientRn: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(DashboardView);
